import React from "react";
import ReactDOMServer from "react-dom/server";
import styles from "@kursk/components/ui/MapForCatalog/MapForCatalog.module.scss";
import { ICON_PATHS } from "../constants/constants";

export const useClusterIconLayouts = () => {
  const createClusterLayout = (imageSrc: string) =>
    ReactDOMServer.renderToString(
      <div>
        <img
          style={{ height: 70 }}
          srcSet={imageSrc}
          alt="cluster"
        />
        <div className={styles.clusterItemsNumber}>
          {'{{ properties.geoObjects.length }}'}
        </div>
      </div>
    );

  return {
    clusterIconLayout: createClusterLayout(ICON_PATHS.CLUSTER),
    clusterIconLayoutHovered: createClusterLayout(ICON_PATHS.CLUSTER_HOVERED),
    clusterIconLayoutActive: createClusterLayout(ICON_PATHS.CLUSTER_ACTIVE),
  };
};
